import { RuntimeSummaryScreen } from '@/features/unified-learning/runtime/screens/RuntimeSummaryScreen';

export default function LearnPathSummaryRoute() {
  return <RuntimeSummaryScreen />;
}
